import type { ProLayoutProps } from '@ant-design/pro-components';
import { brand } from '../src/theme';

/**
 * Layout chrome. Three destinations do not need a sidebar, so the navigation
 * sits in the header and the whole width of the screen belongs to the tables.
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: brand.primary,
  layout: 'top',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Sync',
  pwa: true,
  logo: '/logo.svg',
  iconfontUrl: '',
  siderMenuType: 'sub',
  token: {
    header: {
      colorBgHeader: brand.surface,
      colorTextMenu: brand.body,
      colorTextMenuSelected: brand.primary,
      colorTextMenuActive: brand.ink,
      colorBgMenuItemSelected: '#eef3ff',
      heightLayoutHeader: 56,
    },
    pageContainer: {
      paddingBlockPageContainerContent: 20,
      paddingInlinePageContainerContent: 24,
      colorBgPageContainer: brand.canvas,
    },
  },
};

export default Settings;
